import React, { useState } from "react";
import { Plus } from "lucide-react";

import { CardWithTitle } from "components/helpers/CardWithTitle/CardWithTitle";
import { Dialog } from "components/ui/Dialog";

import { AddMedicalHistoryForm } from "./Form/AddMedicalHistoryForm";
import { MedicalHistory } from "./MedicalHistory";

export const MedicalHistoryCard = ({
  detailsColumnWidth,
  dateRecorderColumnWidth,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <CardWithTitle
        title={"Medical History"}
        width={"100%"}
        buttonTitle={"Add new"}
        endIcon={Plus}
        className={"addNewBtn"}
        onButtonClick={() => setIsModalOpen(true)}
      >
        <MedicalHistory
          detailsColumnWidth={detailsColumnWidth}
          dateRecorderColumnWidth={dateRecorderColumnWidth}
        />
      </CardWithTitle>
      <Dialog
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Add Medical History"
        width={600}
      >
        <AddMedicalHistoryForm closeModal={() => setIsModalOpen(false)} />
      </Dialog>
    </>
  );
};
